; (function ($) {
    $.extend($.fn, {
        bindLast: function (event, cbFunc) {
            return this.each(function () {
                var highIndex = 1000000;
                var eventData = event.split('.');
                var eventName = eventData[0];

                $(this).on(event, cbFunc); //MLK - changed syntax b/c of jquery 3.0 upgrade depreciated bind $(this).bind(event, cbFunc);

                var events = $._data($(this)[0], 'events'), //$(this).data('events'),  //MLK - changed syntax b/c of jquery 1.9 upgrade depreciated .data('events')
					      ourIndex = false,
					      usedIndicies = {};

                $.each(events[eventName], function (index, func) {
                    if (func === cbFunc) {
                        ourIndex = index;
                    }
                    usedIndicies[index] = 1;
                });

                if (ourIndex !== false) {
                    while (usedIndicies[highIndex] == 1) {
                        highIndex++;
                    }

                    events[eventName][highIndex] = events[eventName][ourIndex];
                    delete events[eventName][ourIndex]

                   $._data($(this)[0], 'events', events); //$(this).data('events', events); //MLK - changed syntax b/c of jquery 1.9 upgrade depreciated .data('events')
                }
            });
        }
    });
})(jQuery);